import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js"
import { createElement } from "@uenf/layout";
import { routes } from "../routes";

export default class extends Controller {
  static targets = ["centrosSelect", "programasSelect"];
  static values = { allWhenEmpty: Boolean };

  async change() {
    const queryParams = { programa_centro_id: this.centrosSelectTarget.value };
    if (this.allWhenEmptyValue) { queryParams.all_when_empty = true; }
    const response = await get(
      routes.queryProgramasPath(queryParams),
      { responseKind: "json" }
    );

    this.programasSelectTarget.innerHTML = "";

    if (response.ok) {
      this.programasSelectTarget.appendChild(createElement("option", { value: "" }));
      const programasData = await response.json;
      programasData.forEach(programa => {
        this.programasSelectTarget.appendChild(
          createElement("option", { value: programa.id }, programa.nome)
        );
      });
    }
  }
};
